export default {
  'switch.form.case': 'Caso',
  'switch.form.addCase': 'Agregar caso',
  'switch.form.noCases': 'Aún no hay casos. Agrega al menos uno.',
  'switch.form.enabled': 'Habilitado',
  'switch.form.disabled': 'Deshabilitado',
  'switch.form.nextAction': 'Acción siguiente',
  'switch.form.addGroup': 'Agregar grupo',
  'switch.form.addCondition': 'Agregar condición',
  'switch.form.noGroups': 'Aún no hay grupos de condiciones. Agrega al menos uno.',
  'switch.form.valueSource': 'Origen del valor',
  'switch.form.sourceForm': 'Formulario',
  'switch.form.sourceField': 'Campo',
  'switch.form.sourceVariable': 'Variable',
  'switch.form.sourceIterationTableFieldChild': 'Campo de tabla (iteración)',
  'switch.form.sourceIterationDynamicEntityFieldChild': 'Campo de entidad dinámica (iteración)',
  'switch.form.comparisonOperator': 'Operador',
  'switch.form.value': 'Valor',
  'switch.form.select.formField': 'Campo de formulario',
  'switch.form.select.variable': 'Variable',
  'switch.form.select.iterationStepData': 'Datos del paso de iteración',
  'switch.form.select.Equal': 'Igual a',
  'switch.form.select.NotEqual': 'Distinto de',
  'switch.form.select.GreaterThan': 'Mayor que',
  'switch.form.select.GreaterThanOrEqual': 'Mayor o igual que',
  'switch.form.select.LessThan': 'Menor que',
  'switch.form.select.LessThanOrEqual': 'Menor o igual que',
  'switch.form.select.Contains': 'Contiene',
  'switch.form.select.NotContains': 'No contiene',
  'switch.form.select.IsNull': 'Es nulo',
  'switch.form.select.IsNotNull': 'No es nulo',
  'switch.validation.missingNextAction':
    'El caso {order} está habilitado pero no tiene acción siguiente.',
  'switch.validation.missingConditions':
    'El caso {order} está habilitado pero no tiene condiciones.',
};
